import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.m}rem;
  padding: ${({ theme }) => theme.spaces.m}rem 0;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.spaces.s}rem;
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  border-radius: 0.5rem;
  font-size: 0.875rem;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const WidgetList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  max-height: 15rem;
  overflow-y: auto;
`;

export const WidgetItem = styled.li<{ $isSelected: boolean }>`
  padding: ${({ theme }) => theme.spaces.s}rem;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  background: ${({ $isSelected, theme }) =>
    $isSelected ? theme.colors.greyVeryLight : 'transparent'};
  border: 1px solid
    ${({ $isSelected, theme }) =>
      $isSelected ? theme.colors.primary : theme.colors.greyLight};

  &:hover {
    background: ${({ theme }) => theme.colors.greyLight};
  }
`;

export const EmptyState = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.greySilver};
  font-size: 0.875rem;
  padding: ${({ theme }) => theme.spaces.l}rem 0;
`;

export const AddButton = styled.button`
  align-self: flex-end;
  padding: ${({ theme }) => theme.spaces.s}rem ${({ theme }) => theme.spaces.l}rem;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;
